import * as React from 'react';
import { connect, ConnectedComponent } from 'react-redux';
import { Dispatch } from 'redux';

import * as I from '../../../../../interfaces/merchants/resources/books';
import { init } from '../../../../../redux/actions/merchants/resources/books';

import BaseLayoutMerchantOnlyFooter from '../../../../common/layouts/BaseLayoutMerchantOnlyFooter';
import BookingErrorPage from '../common/BookingErrorPage';
import BookingLoadingPage from '../common/BookingLoadingPage';
import ModelTypeCourse from './ModelTypeCourse';
import ModelTypeCourseWithStaff from './ModelTypeCourseWithStaff';
import ModelTypeEvent from './ModelTypeEvent';
import ModelTypeSchool from './ModelTypeSchool';

import css from './index.module.scss';

interface ElementProps {
  merchantId: string;
  isAccepting?: boolean;
  resourceId: string;
  selectedDate?: string;
  selectedSlot?: string;
  selectedLesson?: string;
  selectedCourse?: string;
  selectedStaff?: string;
}

interface StateProps {
  books: I.State;
}

interface DispatchProps {
  dispatch: Dispatch;
}

type Props = ElementProps & StateProps & DispatchProps;

const CONTROLLER_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [modelType in I.ModelType]: ConnectedComponent<any, any> | undefined;
} = {
  [I.ModelType.AvailabilityScheme]: ModelTypeCourse,
  [I.ModelType.RequestScheme]: undefined, // ModelTypeCommunication,
  [I.ModelType.EventScheme]: ModelTypeEvent,
  [I.ModelType.AssignScheme]: ModelTypeCourseWithStaff,
  [I.ModelType.SchoolScheme]: ModelTypeSchool,
};

class MerchantExpressBookPage extends React.Component<Props> {
  public async componentDidMount() {
    const {
      dispatch,
      merchantId,
      resourceId,
      selectedDate,
      selectedSlot,
      selectedLesson,
      selectedCourse,
      selectedStaff,
    } = this.props;
    init({
      merchantId,
      resourceId,
      selectedDate,
      selectedSlot,
      selectedLesson,
      selectedCourse,
      selectedStaff,
    })(dispatch);
  }

  public render() {
    const {
      isAccepting,
      books: { settings, step, merchantResource },
    } = this.props;

    if (!settings || step === undefined || !merchantResource) {
      return <BookingLoadingPage />;
    }

    const ControllerComponent = CONTROLLER_COMPONENTS[settings.modelType];
    if (!ControllerComponent || step === null) {
      return null;
    }

    return (
      <BaseLayoutMerchantOnlyFooter className={css.Index}>
        <div className={css.Index__BooksArea}>
          <div className={css.Index__BooksContent}>
            {isAccepting && <ControllerComponent />}
            {!isAccepting && <BookingErrorPage withExpressFlow={true} />}
          </div>
        </div>
      </BaseLayoutMerchantOnlyFooter>
    );
  }
}

const mapStateProps = ({
  merchantsResourcesBooks,
}: {
  merchantsResourcesBooks: I.State;
}): StateProps => ({
  books: merchantsResourcesBooks,
});

export default connect(mapStateProps)(MerchantExpressBookPage);
